import { ApolloError } from "@apollo/client";

const formatNetworkExtensions = (extensions: Record<string, any>): string => {
  let details = "";
  for (const extensionKey of Object.keys(extensions)) {
    if (extensionKey === "code" || extensionKey === "field") continue;
    details += `\n ${extensions[extensionKey]}`;
  }
  return details;
};

const formatNetworkErrors = (networkErrors: any[]): string => {
  let errorMessage = "";
  for (const error of networkErrors) {
    errorMessage += error.message;
    if (error?.extensions) {
      errorMessage += formatNetworkExtensions(error.extensions);
    }
  }
  return errorMessage;
};

const formatGraphQLExtensions = (
  extensions: Record<string, any>,
  extensionKeys: string[]
): string => {
  let details = "";
  let counter = 0;
  for (const extensionKey of extensionKeys) {
    counter++;
    if (extensionKey === "code") continue;
    details += `\n ${extensions[extensionKey]}${
      extensionKeys.length === counter ? "." : ", "
    }`;
  }
  return details;
};

const formatGraphQLErrors = (graphQLErrors: readonly any[]): string => {
  let errorMessage = "";
  for (const error of graphQLErrors) {
    errorMessage += error.message;
    if (!error?.extensions) continue;

    const extensionKeys = Object.keys(error.extensions);
    // A populated extensions object replaces the message collected so far.
    if (extensionKeys.length > 0) errorMessage = "";
    errorMessage += formatGraphQLExtensions(error.extensions, extensionKeys);
  }
  return errorMessage;
};

export const formatApolloError = (apolloError: ApolloError) => {
  const networkErrors = (apolloError?.networkError as any)?.result?.errors;
  if (networkErrors) {
    return formatNetworkErrors(networkErrors);
  }
  if (apolloError.graphQLErrors.length === 0) {
    return apolloError?.message ?? "An unknown error occured";
  }
  return formatGraphQLErrors(apolloError.graphQLErrors);
};